var $b7a611726449f4a3$exports = {};
$b7a611726449f4a3$exports = {
  "Clear search": "\uAC80\uC0C9 \uC9C0\uC6B0\uAE30"
};
export { $b7a611726449f4a3$exports as default };